// extracted by mini-css-extract-plugin
export default {"customTable":"style_customTable__OPG+W"};